import es from "./locales/es";
import { DEFAULT_LOCALE } from "./locale";

// English text is the key, so English output is the source string untouched.
const catalogs = { es };

const interpolate = (text, params) =>
  params
    ? text.replace(/\{(\w+)\}/g, (match, name) =>
        params[name] === undefined ? match : params[name]
      )
    : text;

export const translate = (locale, text, params) => {
  if (typeof text !== "string") {
    return text;
  }
  const catalog = catalogs[locale];
  const translated =
    catalog && Object.prototype.hasOwnProperty.call(catalog, text)
      ? catalog[text]
      : text;
  return interpolate(translated, params);
};

const translators = {};

// One function per locale, so it is safe to use as a context value.
export const getTranslator = locale => {
  if (!translators[locale]) {
    translators[locale] = (text, params) => translate(locale, text, params);
  }
  return translators[locale];
};

export const translateErrors = (errors, locale) => {
  if (!errors || locale === DEFAULT_LOCALE) {
    return errors;
  }
  return Object.keys(errors).reduce((translated, field) => {
    translated[field] = translate(locale, errors[field]);
    return translated;
  }, {});
};
